import Documents from "./documents"

export default Documents
